import { createAction } from '@reduxjs/toolkit';

export const STOP_STREAMS_ACTION_TYPE = 'saga/stopStreams';
export const stopStreamsAction = createAction(STOP_STREAMS_ACTION_TYPE);
